import React, { Component } from 'react';
import $ from 'jquery';

class BillSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            query: '',
            results: [],
            loading: false,
            searched: false
        };
        this.searchTimeout = null;
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.performSearch = this.performSearch.bind(this);
        this.selectBill = this.selectBill.bind(this);
    }

    open() {
        this.setState({ query: '', results: [], loading: true, searched: false });
        $("#bill-selector-component").modal('show');
        this.loadRecent();
    }

    loadRecent() {
        const api = this.props.getApi();
        const params = [
            { name: 'page', value: 1 },
            { name: 'limit', value: 10 },
            { name: 'verifactu_status', value: 'Correcto,ParcialmenteCorrecto' }
        ];
        api.getBills(params, (response) => {
            if (response.status === 'OK') {
                this.setState({ results: response.bills || [], loading: false, searched: true });
            } else {
                this.setState({ results: [], loading: false, searched: true });
            }
        });
    }

    close() {
        $("#bill-selector-component").modal('hide');
    }

    handleQueryChange(e) {
        const query = e.target.value;
        this.setState({ query });
        clearTimeout(this.searchTimeout);
        if (query.length === 0) {
            this.setState({ results: [], loading: true, searched: false });
            this.loadRecent();
            return;
        }
        if (query.length < 2) {
            return;
        }
        this.searchTimeout = setTimeout(() => this.performSearch(query), 350);
    }

    performSearch(query) {
        this.setState({ loading: true });
        const api = this.props.getApi();
        const params = [
            { name: 'billCode', value: query },
            { name: 'page', value: 1 },
            { name: 'limit', value: 20 },
            { name: 'verifactu_status', value: 'Correcto,ParcialmenteCorrecto' }
        ];
        api.getBills(params, (response) => {
            if (response.status === 'OK') {
                this.setState({ results: response.bills || [], loading: false, searched: true });
            } else {
                this.setState({ results: [], loading: false, searched: true });
            }
        });
    }

    selectBill(bill) {
        this.close();
        if (this.props.onBillSelected) this.props.onBillSelected(bill);
    }

    formatDate(dateStr) {
        if (!dateStr) return '';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('es-ES');
        } catch (e) {
            return dateStr;
        }
    }

    formatAmount(bill) {
        if (bill.total_price != null) return parseFloat(bill.total_price).toFixed(2) + ' €';
        return '';
    }

    getClientName(bill) {
        if (!bill.client) return '';
        if (typeof bill.client === 'object') {
            return [bill.client.name, bill.client.lastname].filter(Boolean).join(' ');
        }
        return '';
    }

    render() {
        const { query, results, loading, searched } = this.state;

        return (
            <div className="modal fade" id="bill-selector-component" tabIndex="-1" role="dialog"
                aria-labelledby="BillSelectorLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="BillSelectorLabel">Seleccionar factura</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar por código de factura..."
                                    value={query}
                                    onChange={this.handleQueryChange}
                                    autoFocus
                                />
                            </div>
                            {loading && <p className="text-muted">Buscando...</p>}
                            {!loading && searched && results.length === 0 && (
                                <p className="text-muted">No se encontraron facturas.</p>
                            )}
                            {!loading && results.length > 0 && (
                                <table className="table table-striped table-hover" style={{ cursor: 'pointer' }}>
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            <th>Fecha</th>
                                            <th>Cliente</th>
                                            <th className="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {results.map((bill, idx) => (
                                            <tr key={bill._id || idx} onClick={() => this.selectBill(bill)}>
                                                <td>{bill.code}</td>
                                                <td>{this.formatDate(bill.creation_date)}</td>
                                                <td>{this.getClientName(bill)}</td>
                                                <td className="text-right">{this.formatAmount(bill)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BillSelector;
